export default "__VITE_PUBLIC_ASSET__2bd9f35e__"